import { Routes } from '@angular/router';
import { VenueListComponent } from './venue-list/venue-list.component';

export const routes: Routes = [
    { path: '', redirectTo: 'venues', pathMatch: 'full' },
    {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
    },
    {
        path: 'menu-item-templates',
        loadComponent: () => import('./menu-item-templates/menu-item-templates.component').then(m => m.MenuItemTemplatesComponent)
    },
    { path: 'menu-items', redirectTo: 'menu-item-templates', pathMatch: 'full' },
    {
        // Landing route: bundled eagerly so the first paint after the auth gate
        // doesn't wait on an extra chunk round trip.
        path: 'venues',
        component: VenueListComponent
    },
    {
        path: 'archive',
        loadComponent: () => import('./archive/archive.component').then(m => m.ArchiveComponent)
    },
    {
        path: 'trash',
        loadComponent: () => import('./trash/trash.component').then(m => m.TrashComponent)
    },
    {
        path: 'venues/:id',
        loadComponent: () => import('./venue-detail/venue-detail.component').then(m => m.VenueDetailComponent)
    },
    {
        path: 'venues/:id/checkout',
        loadComponent: () => import('./checkout/checkout.component').then(m => m.CheckoutComponent)
    },
    {
        path: 'venues/:id/plan',
        loadComponent: () => import('./plan-detail/plan-detail.component').then(m => m.PlanDetailComponent)
    },
    {
        path: 'venues/:id/orders',
        loadComponent: () => import('./orders/orders.component').then(m => m.OrdersComponent)
    },
    {
        path: 'venues/:id/orders/:orderId',
        loadComponent: () => import('./order-detail/order-detail.component').then(m => m.OrderDetailComponent)
    },
    {
        path: 'venues/:id/terminals',
        loadComponent: () => import('./terminals/terminals.component').then(m => m.TerminalsComponent)
    },
    {
        path: 'venues/:id/raw-data',
        loadComponent: () => import('./raw-data-lookup/raw-data-lookup.component').then(m => m.RawDataLookupComponent)
    },
    {
        path: 'venues/:id/menu-items',
        loadComponent: () => import('./venue-menu-items/venue-menu-items.component').then(m => m.VenueMenuItemsComponent)
    },
    {
        path: 'venues/:id/menus',
        loadComponent: () => import('./venue-menus/venue-menus.component').then(m => m.VenueMenusComponent)
    },
    {
        path: 'venues/:id/activity-log',
        loadComponent: () => import('./activity-log/activity-log.component').then(m => m.ActivityLogComponent)
    },
    {
        path: 'venues/:id/migrations',
        loadComponent: () => import('./migrations/migrations.component').then(m => m.MigrationsComponent)
    },
    {
        path: 'venues/:id/chat-audit',
        loadComponent: () => import('./chat-audit/chat-audit.component').then(m => m.ChatAuditComponent)
    },
    {
        path: 'venues/:id/genai-usage',
        loadComponent: () => import('./genai-usage/genai-usage.component').then(m => m.GenaiUsageComponent)
    },
    {
        path: 'venues/:id/asset-usage',
        loadComponent: () => import('./asset-usage/asset-usage.component').then(m => m.AssetUsageComponent)
    },
    {
        path: 'venues/:id/configuration',
        loadComponent: () => import('./venue-configuration/venue-configuration.component').then(m => m.VenueConfigurationComponent)
    },
    {
        path: 'venues/:id/staff',
        loadComponent: () => import('./venue-staff/venue-staff.component').then(m => m.VenueStaffComponent)
    },
    {
        path: 'venues/:id/destruction-zone',
        loadComponent: () => import('./destruction-zone/destruction-zone.component').then(m => m.DestructionZoneComponent)
    },
    {
        path: 'venues/:id/payment-summaries',
        loadComponent: () => import('./payment-summaries/payment-summaries.component').then(m => m.PaymentSummariesComponent)
    },
    {
        path: 'tools/app-remote-config',
        loadComponent: () => import('./tools/app-remote-config/app-remote-config.component').then(m => m.AppRemoteConfigComponent)
    },
    {
        path: 'tools/ai-usage',
        loadComponent: () => import('./tools/ai-usage/ai-usage.component').then(m => m.AiUsageComponent)
    },
    {
        path: 'tools/audit',
        loadComponent: () => import('./tools/audit/audit.component').then(m => m.AuditComponent)
    },
    {
        path: 'tools/competitor-analysis',
        loadComponent: () => import('./tools/competitor-analysis/competitor-analysis.component').then(m => m.CompetitorAnalysisComponent)
    },
    {
        path: 'tools/device-management',
        loadComponent: () => import('./tools/device-management/device-management.component').then(m => m.DeviceManagementComponent)
    },
    {
        path: 'tools/environment',
        loadComponent: () => import('./tools/environment-configuration/environment-configuration.component').then(m => m.EnvironmentConfigurationComponent)
    },
    {
        path: 'tools/lookup',
        loadComponent: () => import('./tools/lookup/lookup.component').then(m => m.LookupComponent)
    },
    {
        path: 'tools/manage-users',
        loadComponent: () => import('./tools/manage-users/manage-users.component').then(m => m.ManageUsersComponent)
    },
    {
        path: 'tools/maps',
        loadComponent: () => import('./tools/maps/maps.component').then(m => m.MapsComponent)
    },
    {
        path: 'tools/qr-tester',
        loadComponent: () => import('./tools/qr-tester/qr-tester.component').then(m => m.QrTesterComponent)
    },
    {
        path: 'tools/repro',
        loadComponent: () => import('./tools/repro/repro.component').then(m => m.ReproComponent)
    },
    {
        path: 'tools/order-extraction',
        loadComponent: () => import('./tools/order-extraction/order-extraction.component').then(m => m.OrderExtractionComponent)
    },
    {
        path: 'tools/order-simulation',
        loadComponent: () => import('./tools/order-simulation/order-simulation.component').then(m => m.OrderSimulationComponent)
    },
    {
        path: 'tools/voice-simulation',
        loadComponent: () => import('./tools/voice-simulation/voice-simulation.component').then(m => m.VoiceSimulationComponent)
    },
    {
        path: 'venues/:id/repro',
        loadComponent: () => import('./tools/repro/repro.component').then(m => m.ReproComponent)
    },
    {
        path: 'tools/sign-up-leads',
        loadComponent: () => import('./tools/sign-up-leads/sign-up-leads.component').then(m => m.SignUpLeadsComponent)
    },
    {
        path: 'tools/technical-dashboard',
        loadComponent: () => import('./tools/technical-dashboard/technical-dashboard.component').then(m => m.TechnicalDashboardComponent)
    },
    {
        path: 'tools/platform-configuration',
        loadComponent: () => import('./tools/platform-configuration/platform-configuration.component').then(m => m.PlatformConfigurationComponent)
    },
    { path: 'tools/marketing-coverage', redirectTo: 'tools/marketing/coverage', pathMatch: 'full' },
    {
        path: 'tools/marketing/coverage',
        loadComponent: () => import('./tools/marketing/coverage/marketing-coverage.component').then(m => m.MarketingCoverageComponent)
    },
    {
        path: 'tools/marketing/signups',
        loadComponent: () => import('./tools/marketing/signups/marketing-signups.component').then(m => m.MarketingSignupsComponent)
    },
    {
        path: 'tools/chat/capabilities',
        loadComponent: () => import('./tools/chat-capabilities/chat-capabilities.component').then(m => m.ChatCapabilitiesComponent)
    },
    {
        path: 'tools/chat/regression',
        loadComponent: () => import('./tools/chat-regression/chat-regression.component').then(m => m.ChatRegressionComponent)
    },
    {
        path: 'tools/chat/venues',
        loadComponent: () => import('./tools/venue-chat/venue-chat.component').then(m => m.VenueChatComponent)
    },
    {
        path: 'tools/admin-chat-audit',
        loadComponent: () => import('./tools/admin-chat-audit/admin-chat-audit.component').then(m => m.AdminChatAuditComponent)
    },
    {
        path: 'tools/chat-context',
        loadComponent: () => import('./tools/chat-context/chat-context.component').then(m => m.ChatContextComponent)
    },
    {
        path: 'tools/venue-activity',
        loadComponent: () => import('./tools/venue-activity/venue-activity.component').then(m => m.VenueActivityComponent)
    },
    {
        path: 'tools/venue-compare',
        loadComponent: () => import('./tools/venue-compare/venue-compare.component').then(m => m.VenueCompareComponent)
    },
    {
        path: 'tools/venue-template',
        loadComponent: () => import('./tools/venue-template/venue-template.component').then(m => m.VenueTemplateComponent)
    },
    {
        path: 'tools/menu-management',
        loadComponent: () => import('./tools/menu-management/menu-management.component').then(m => m.MenuManagementComponent)
    },
    {
        path: 'tools/venue-studio',
        loadComponent: () => import('./tools/venue-studio/venue-studio.component').then(m => m.VenueStudioComponent)
    },
    {
        path: 'tools/knowledge-base',
        loadComponent: () => import('./tools/knowledge-base/knowledge-base.component').then(m => m.KnowledgeBaseComponent)
    },
    {
        path: 'tools/knowledge-transfer',
        loadComponent: () => import('./tools/knowledge-base/knowledge-transfer.component').then(m => m.KnowledgeTransferComponent)
    },
    {
        path: 'tools/knowledge-base/:articleId',
        loadComponent: () => import('./tools/knowledge-base/kb-article.component').then(m => m.KbArticleComponent)
    },
    {
        path: 'support',
        loadComponent: () => import('./support-tickets/ticket-queue.component').then(m => m.TicketQueueComponent)
    },
    {
        path: 'support/settings',
        loadComponent: () => import('./support-tickets/support-settings.component').then(m => m.SupportSettingsComponent)
    },
    {
        path: 'support/on-call',
        loadComponent: () => import('./support-tickets/on-call.component').then(m => m.OnCallComponent)
    },
    {
        path: 'support/new',
        loadComponent: () => import('./support-tickets/ticket-create.component').then(m => m.TicketCreateComponent)
    },
    {
        path: 'support/:venueId/:ticketId',
        loadComponent: () => import('./support-tickets/ticket-triage.component').then(m => m.TicketTriageComponent)
    }
];